// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import { __ } from '../../i18n/l10n';
import theme from '../../styled-components/dark';

const Wrapper = styled.div`
  border-radius: 1.3em;
  border: none;
  height: 1.8em;
  padding: 0 1em;

  background: transparent;
  border: 1px solid ${theme.BasketCombinationsSliderCell.borderColor};
  box-shadow: 0 0.3em 0.5em 0 rgba(0, 0, 0, 0.5);

  font-weight: 800;
  font-size: 0.8em;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Center = styled.span``;

const Label = styled.span`
  color: ${theme.BasketCombinationsSliderCell.labelColor};
`;

const NbBets = styled.span`
  color: ${theme.BasketCombinationsSliderCell.counterColor};
`;

export type BasketCombinationsSliderCellDataType = {
  label: string;
  counter: number;
};

type BasketCombinationsSliderCellProps = BasketCombinationsSliderCellDataType & {
  className?: string;
};

const BasketCombinationsSliderCell = ({ className, label, counter }: BasketCombinationsSliderCellProps) => {
  const shouldDisplay = useMemo(() => !!label, [label]);

  if (shouldDisplay) {
    return (
      <Wrapper className={className}>
        <Center>
          <Label>{label}</Label> {counter ? <NbBets>({__('%1$s bet', counter, '%1$s bets')})</NbBets> : null}
        </Center>
      </Wrapper>
    );
  }
  return null;
};

export default BasketCombinationsSliderCell;
